import styled from "styled-components";
import { injectInputColumnsResponsiveStyles } from "../../../../input-columns-responsive-styles";

injectInputColumnsResponsiveStyles();

export const StyledLimitSortWrapper = styled.div.attrs({
  className: "au-limit-sort",
})`
  display: flex;
`;

export const StyledLimitItem = styled.div.attrs({
  className: "au-limit-sort-limit",
})`
  width: 50%;
  margin-right: 6px;
`;

export const StyledSortByItem = styled.div.attrs({
  className: "au-limit-sort-by",
})`
  width: 37%;
`;

export const StyledSortDirectionItem = styled.div.attrs({
  className: "au-limit-sort-direction",
})`
  margin-left: 10px;
  width: 13%;
  display: flex;
  label {
    height: 18px;
  }
`;
